import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './LinkDropdown.scss';
export interface LinkDropdownItem {
  label: string;
  value: () => void;
}

export enum LinkButtonDirection {
  left = 'left',
  default = 'default',
}
export interface LinkDropdownProps {
  /**
   * Button name
   */
  label: string | JSX.Element;
  /**
   * Button contents
   */
  items: LinkDropdownItem[];
  /**
   * Additional class names
   */
  className?: string;

  /**
   * control disabled
   */
  disabled?: boolean;

  /**
   * popup direction
   */
  direction?: LinkButtonDirection;
}

/**
 * Primary UI component for user interaction
 */
export const LinkDropdownProvider: React.FC<LinkDropdownProps> = (props) => {
  const [direction, setDirection] = useState<LinkButtonDirection>(LinkButtonDirection.default);
  const [dropdownOpen, setOpen] = useState(false);
  const ref = useRef<any>(null);

  useEffect(() => {
    if (props.direction && props.direction !== direction) {
      setDirection(props.direction);
    }
  }, [props.direction]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const toggle = () => {
    setOpen(!dropdownOpen);
  };

  const handleOptionClick = (item: LinkDropdownItem) => {
    item.value();
    setOpen(false);
  };

  return (
    <span className={classNames(styles['dropdown'])} ref={ref}>
      <a href="javascript:void(0)" onClick={() => toggle()} className={classNames(props.className)}>
        {props.label}
      </a>
      <div className={classNames(styles['dropdown-content'], styles[direction], dropdownOpen ? styles['show'] : '')}>
        {props.items.map((x, i) => {
          return (
            <a key={i} href="javascript:void(0)" onClick={() => handleOptionClick(x)}>
              {x.label}
            </a>
          );
        })}
      </div>
    </span>
  );
};
